module.exports = __webpack_public_path__ + "static/animationSlideImage3-3e64d1cfcca2f1253ae24094bceaf8e3.png";